import { GetServerSideProps } from 'next'
import { useEffect, useState } from 'react'
import { Container } from '../../components/core/container/Container'
import { Link } from '../../components/core/link/Link'
import { Section } from '../../components/core/section/Section'
import { Text } from '../../components/core/text/Text'
import Meta from '../../components/meta/Meta'
import s from '../../styles/pages/Articles.module.scss'
import { Filters } from '../../components/core/filters/Filters'
import Masonry from 'react-masonry-css'
import { uuid4 } from '@sentry/utils'
import { useDevice } from '../../hooks/useDevice'
import episodes from '../../episodes'
import { GalleryWithTimer } from '../../components/components/galleryWithTimer/GalleryWithTimer'
import algoliasearch from 'algoliasearch'
import DumbArticle from '../../components/cards/dumbArticle'

const client = algoliasearch(
    process.env.NEXT_PUBLIC_ALGOLIA_APPLICATION_ID,
    process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_API_KEY
)
const index = client.initIndex('memories')

export const getServerSideProps: GetServerSideProps = async ({ res }) => {
    res.setHeader(
        'Cache-Control',
        'max-age=0, s-maxage=1, stale-while-revalidate'
    )

    const ref = await fetch('https://minningar.prismic.io/api/v2/')
        .then((response) => response.json())
        .then((result) => result.refs[0].ref)

    const fraedslugreinar = await fetch(
        `https://minningar.prismic.io/api/v2/documents/search?q=[[any(document.type,["frodleikur-grein"])]]&orderings=[document.first_publication_date desc]&ref=${ref}&access_token=MC5Za0xycHhJQUFDd0FtVWdr.77-9QO-_vSdPK--_vRnvv73vv71pBDlKd--_ve-_ve-_ve-_ve-_ve-_ve-_vVDvv70caO-_ve-_ve-_vR1cfg`
    )
        .then((response) => response.json())
        .then((result) => result)

    const hagnytar = await fetch(
        `https://minningar.prismic.io/api/v2/documents/search?q=[[any(document.type,["blog"])]]&orderings=[document.first_publication_date desc]&ref=${ref}&access_token=MC5Za0xycHhJQUFDd0FtVWdr.77-9QO-_vSdPK--_vRnvv73vv71pBDlKd--_ve-_ve-_ve-_ve-_ve-_ve-_vVDvv70caO-_ve-_ve-_vR1cfg`
    )
        .then((response) => response.json())
        .then((result) => result)

    const list = []
    hagnytar.results.map((item) => {
        const obj = {
            imgSrc:
                item.data.shareimage.url ||
                item.data.slices[0].primary.image.url,
            tag: 'Hagnýtt',
            date: item.first_publication_date,
            title: item.data.titill[0].text,
            paragraph:
                (item.data.slices[0].primary.title &&
                    item.data.slices[0].primary.title[0].text) ||
                item.data.slices?.data.sharedescription,
            link: '/advice/' + item.uid,
        }

        list.push(obj)
    })

    fraedslugreinar.results.map((item) => {
        if (
            item.uid === 'thorarinn-eldjarn' ||
            item.uid === 'sera-jona-hronn-bolladottir'
        ) {
            return
        }

        const obj = {
            imgSrc:
                item.data.shareimage.url ||
                item.data.slices[0].primary.image.url,
            tag: 'Viðtal',
            date: item.first_publication_date,
            title: item.data.titill[0].text,
            paragraph: item.data.body[0].primary.title[0].text,
            link: '/articles/' + item.uid,
        }

        list.push(obj)
    })

    episodes.map((item) => {
        const obj = {
            imgSrc: item.thumbnail,
            tag: 'Hlaðvarp',
            date: item.date,
            title: item.title,
            paragraph: item.paragraph,
            link: '/podcast?vidId=' + item.videoId,
        }
        list.push(obj)
    })

    list.sort(function (a, b) {
        // Turn your strings into dates, and then subtract them
        // to get a value that is either negative, positive, or zero.
        const ad = new Date(a.date) as any
        const bd = new Date(b.date) as any

        return bd - ad
    })

    let memHits = {}

    // Get all the memories hits from firebase with algolia
    try {
        memHits = await index.search('')
    } catch (e) {
        console.error((e as Error).message)
    }

    return {
        props: {
            result: JSON.stringify(list),
            memHits,
        },
    }
}

const Articles = ({ result, memHits }) => {
    const device = useDevice()

    const articles = JSON.parse(result)
    // console.log(articles)

    const [filterIndex, setFilterIndex] = useState(-1)
    const [firstArticle, setFirstArticle] = useState(articles[0])

    const [middleArticles, setMiddleArticles] = useState(articles?.slice(1, 7))
    const [lastArticles, setLastArticles] = useState(
        articles.slice(7, articles.lenght)
    )

    // UseEffect for filtering
    useEffect(() => {
        const indexList = ['Viðtal', 'Hagnýtt', 'Hlaðvarp']
        let filteredArticles
        if (filterIndex !== -1) {
            filteredArticles = articles.filter((article) => {
                return article.tag === indexList[filterIndex]
            })
        } else {
            filteredArticles = articles
        }
        if (filteredArticles.length !== 0) {
            setFirstArticle(filteredArticles[0])
            setMiddleArticles(filteredArticles.slice(1, 7))
            setLastArticles(filteredArticles.slice(7, filteredArticles.length))
        }
    }, [filterIndex])

    if (articles) {
        return (
            <>
                <Meta
                    title="Minningar - Fræðsluefni"
                    seoTitle="Minningar - Fræðsluefni"
                    description=""
                    image="https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/meta%2Fada8aa5a-8e66-41a9-81c6-3b1491a2fd24_iStock-1290101336.jpeg?alt=media&token=dcbc085f-5003-43e6-8d6f-555d9c454ba6"
                    url="https://minningar.is/articles/"
                    type="website"
                />
                <Section>
                    <Container className={s.header}>
                        <Text variant="h1" className={s.header__item}>
                            Fræðsluefni
                        </Text>
                        <Text variant="p-18" className={s.header__item}>
                            Greinasafn Minningar.is er í stöðugri þróun. Ertu
                            með ábendingu um fræðsluefni sem ætti heima á
                            Minningar.is? Endilega skrifaðu okkur á{' '}
                            <Link to="mailto:minningar@minningar.is">
                                minningar@minningar.is
                            </Link>
                        </Text>
                        <Filters
                            filterNames={[
                                'Viðtöl',
                                'Hagnýtar upplýsingar',
                                'Hlaðvarp',
                            ]}
                            className={s.filter}
                            setState={setFilterIndex}
                            selectedIndex={filterIndex}
                        />
                    </Container>
                </Section>
                <Section>
                    <Container className={s.articles}>
                        {device === 'desktop' ? (
                            <>
                                {/* First article */}
                                <div className={s.firstArticle}>
                                    <DumbArticle
                                        key={uuid4()}
                                        id="first"
                                        imgSrc={firstArticle?.imgSrc}
                                        tag={firstArticle?.tag}
                                        date={firstArticle?.date}
                                        title={firstArticle?.title}
                                        paragraph={firstArticle?.paragraph}
                                        link={firstArticle?.link}
                                        style={{
                                            top: 'calc(var(--header-height) + 10px)',
                                        }}
                                        first
                                        className={s.dumbArticle}
                                    />
                                </div>
                                {/* Next 4 articles */}
                                <Masonry
                                    breakpointCols={2}
                                    className={s.middleArticles}
                                    columnClassName={s.middleArticles__column}
                                >
                                    {middleArticles?.map((article) => {
                                        // console.log('test', slices[0].primary)

                                        return (
                                            <DumbArticle
                                                key={uuid4()}
                                                imgSrc={article?.imgSrc}
                                                tag={article?.tag}
                                                date={article?.date}
                                                title={article?.title}
                                                paragraph={article?.paragraph}
                                                link={article?.link}
                                                className={s.dumbArticle}
                                            />
                                        )
                                    })}
                                </Masonry>

                                {/* Rest of articles */}
                                <div className={s.lastArticles}>
                                    {lastArticles?.map((article) => {
                                        return (
                                            <DumbArticle
                                                key={uuid4()}
                                                // key={index}
                                                imgSrc={article?.imgSrc}
                                                tag={article?.tag}
                                                date={article?.date}
                                                title={article?.title}
                                                paragraph={article?.paragraph}
                                                link={article?.link}
                                                className={s.dumbArticle}
                                            />
                                        )
                                    })}
                                </div>
                            </>
                        ) : (
                            <div
                                className={
                                    device === 'mobile' ? s.mobile : s.tablet
                                }
                            >
                                {[
                                    firstArticle,
                                    ...middleArticles,
                                    ...lastArticles,
                                ].map((article) => {
                                    return (
                                        <DumbArticle
                                            key={uuid4()}
                                            imgSrc={article.imgSrc}
                                            tag={article.tag}
                                            date={article.date}
                                            title={article.title}
                                            paragraph={article.paragraph}
                                            link={article.link}
                                            mobile
                                            className={s.dumbArticle}
                                        />
                                    )
                                })}
                            </div>
                        )}
                    </Container>
                </Section>
                <Section>
                    <GalleryWithTimer hits={memHits.hits} />
                </Section>
            </>
        )
    }
    return <></>
}

export default Articles
